<template>
  <section id="layout-container">
    <div class="shr-blue-bg px-md-4 py-md-2">
      <div class="shr-dark-blue-bg container-fluid">
        <div class="row layout-container__header py-3 p-md-4 align-items-center">
          <div class="col-md-9 align-items-center">
            <slot name="header-content-left"></slot>
          </div>

          <div class="col-md-3 text-right">
            <p class="text-white fs-14 d-none d-md-block">
              <slot name="header-content-right"></slot>
            </p>
            <div class="my-2 mt-md-5 d-flex justify-content-md-end justify-content-start">
              <slot name="header-content-right-btn"></slot>
            </div>
          </div>
        </div>
        <div ref="tabDiv"></div>
        <div class="row layout-container__tab-panel d-flex" :class="{ 'is-sticky': isSticky }">
          <div
            v-for="tab in tabs"
            :key="tab.route"
            :class="{
              'layout-container__tab-active': $route.name == tab.routeName,
              'text-white position-relative cursor-pointer px-3 px-md-5 py-2': true
            }"
            @click="goTo(tab.routeName)"
            >
            {{ tab.title }}
          </div>
        </div>
      </div>
      <div class="container-fluid bg-white">
        <div class="row justify-content-center">
          <div class="col-md-4 pl-md-3 py-3">
            <slot name="body-content-right"></slot>
          </div>
          <div class="col-md-8 order-md-first bg-white py-3" :class="{ 'section-scroll': isSticky }">
            <transition name="fade" mode="out-in" appear>
              <router-view
                :isApplicationWithdrawn="isApplicationWithdrawn"
                :jobIsArchived="jobIsArchived"
                :jobIsDeleted="jobIsDeleted"
                :application="application"
                :isLoading="isLoading"
              ></router-view>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LayoutContainer",
  props: {
    tabs: {
      type: Array,
      default: [],
    },
    application: {
      type: Object,
      default: () => ({})
    },
    jobIsArchived: {
      type: Boolean,
      default: false
    },
    jobIsDeleted: {
      type: Boolean,
      default: false
    },
    isApplicationWithdrawn: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
      return {
        isSticky: false,
      };
  },
  mounted() {
    this.$nextTick(()=>{
      const observer = new IntersectionObserver(this.handleIntersect, {
        root: null,
        threshold: 0,
      });
      observer.observe(this.$refs.tabDiv)
    })
  },
  methods: {
    goTo(routeName) {
      // this is to prevent the NavigationDuplicated error
      if (routeName !== this.$route.name) {
        this.$router.push({
          name: routeName,
          params: { id: `${this.$route.params.id}` },
        })
      }
    },
    handleIntersect(entries) {
      const [entry] = entries;
      if(entry.isIntersecting){
        this.isSticky = false
      }else{
        this.isSticky = true
      }
      this.$emit('sticky:header', this.isSticky)
    },
  },
};
</script>

<style lang="scss" scoped>
  .layout-container{
    &__tab-panel{
      height: 44px;
    }
  }
  .is-sticky {
    position: fixed;
    top: 110px;
    left: 0;
    right: 0;
    z-index: 10;
    padding-left: 3rem;
    padding-right: 3rem;
    transform: translateY(-100%);
  }
</style>
